import React, {Component } from 'react';
import {reactLocalStorage} from 'reactjs-localstorage';
import StoreContext from './Context';
import sha256 from 'crypto-js/sha256';
import hmacSHA512 from 'crypto-js/hmac-sha512';
import Base64 from 'crypto-js/enc-base64';
import {validateTokenStorage } from "../Components/Constants/Util";
import{nonce,path,privateKey} from './../Components/Constants/Services';

interface IProviderState {
  allow:boolean;
  per_admin:string;
  token:string;
  usr_type:string;
  per_id:string;
  per_std:string;
  year:string;
  children: any;
  key:string;
}
interface IProviderProps {
  children: any;
}

var x = reactLocalStorage.getObject('tokenP');
if(validateTokenStorage()){
  reactLocalStorage.clear();
}

class StoreProvider extends Component<IProviderProps, IProviderState>{
  constructor(props:IProviderProps) {
    super(props);
    this.state = {
      allow:x.allow,
      per_admin: x.per_admin,
      token:x.token,
      usr_type:x.usr_type,
      per_id:x.per_id,
      per_std:x.per_std,
      year:x.year,
      children: props.children,
      key:x.key
    };

    this.setToken = this.setToken.bind(this);
    this.setStd = this.setStd.bind(this);
    this.setAllow = this.setAllow.bind(this);
    this.setUsrType = this.setUsrType.bind(this);
  }

  getKeyToke({usr_type,per_id,per_admin,per_std}:any){
    const hashKey = sha256(nonce + usr_type+per_id+per_admin+per_std);
    const hmacKey = Base64.stringify(hmacSHA512(path + hashKey, privateKey));
    return hmacKey
  }

  setToken = ({token,usr_type,per_id,year,allow,per_admin}:any)=> {
    const props = this.state;
    const keyToken = this.getKeyToke({usr_type:usr_type,per_id:per_id,per_admin:per_admin,per_std:props.per_std})
    this.setState({
      token,
      usr_type,
      per_id,
      year,
      allow,
      per_admin,
      key:keyToken
    });
    reactLocalStorage.setObject('tokenP',{allow,per_admin,token,usr_type,per_id,per_std:props.per_std,year,key:keyToken});
  }

  setAllow = ({allow}:any)=> {
    const props = this.state;
    this.setState({
      allow
    });
    reactLocalStorage.setObject('tokenP', {allow,per_admin:props.per_admin,token:props.token,usr_type:props.usr_type,per_id:props.per_id,per_std:props.per_std,year:props.year,key:props.key});
  }

  setUsrType = ({usr_type,per_std}:any)=> {
    const props = this.state;
    const keyToken = this.getKeyToke({usr_type,per_id:props.per_id,per_admin:props.per_admin,per_std})
    this.setState({
      usr_type,
      per_std,
      key:keyToken
    });
    reactLocalStorage.setObject('tokenP', {allow:props.allow,per_admin:props.per_admin,token:props.token,usr_type,per_id:props.per_id,per_std,year:props.year,key:keyToken});
  }

  quitToken = ()=> {
    const props = this.state
    if(props.usr_type==="/teachers" && props.allow === true && props.per_admin !== null ){
      const keyToken = this.getKeyToke({usr_type:"/admin",per_id:props.per_admin,per_admin:null,per_std:props.per_std})
      this.setState({
        allow:null,
        per_admin:null,
        token:props.token,
        usr_type:"/admin",
        per_id:props.per_admin,
        per_std:null,
        year:props.year,
        key:keyToken                                         
      });
      reactLocalStorage.setObject('tokenP', {token:props.token,usr_type:"/admin",per_id:props.per_admin,year:props.year,allow:null,per_admin:null});
    }
    else{
      this.setState({
        allow:null,
        token:null,
        usr_type:null,
        per_id:null,
        year:null,
        per_admin:null,
        per_std:null,
        key:null
      });
      reactLocalStorage.clear();
    }
  }

  setStd = ({per_std}:any)=> {
    const props = this.state
    const keyToken = this.getKeyToke({usr_type:props.usr_type,per_id:props.per_id,per_admin:props.per_admin,per_std})
    this.setState({
      per_std,
      key:keyToken
    });
    reactLocalStorage.setObject('tokenP', {allow:true,per_admin:props.per_admin,token:props.token,usr_type:props.usr_type,per_id:props.per_id,per_std,year:props.year,key:keyToken});
  }
  
  render() {
    const props= this.state;
    return (
      <StoreContext.Provider value={{token:props.token,usr_type:props.usr_type,per_id:props.per_id,year:props.year,per_std:props.per_std,allow:props.allow,per_admin:props.per_admin,key:props.key,setToken:this.setToken,setAllow:this.setAllow,setStd:this.setStd,setUsrType:this.setUsrType,quitToken:this.quitToken}}>
            {props.children}
      </StoreContext.Provider>
    );
  }
}

export default StoreProvider;